module.exports = __webpack_public_path__ + "images/stop_point_unArrived.d0e65ee2cf2647fbe56cb849fb9d4f61.png";